<template>
    <div>
        <!-- <div :style="{position:'absolute',right:'20px', top:'4px', textAlign:'right', zIndex:99999}">
            <btn label="confirm" @press="showConfirm" />
            <btn label="success" @press="showAlert('success', {title:'Заголовок ', text:'Текст '})" />
            <btn label="error" @press="showAlert('error', {title:'Заголовок ошибки', text:'Текст ошибки'})" />
            <btn label="input" @press="showInput" />
            <btn label="showInputFrom" @press="showInputFrom" />
        </div> -->
        <div class="overlay animated" :class="{hidden:!visible, fadeIn:(visible&&!willHidden),fadeOut:willHidden}">
            <div class="imodal animated text-center" :class="{
                    fadeInLeft:(visible&&!willHidden),
                    fadeOutRight:(outDirection === 'right' && willHidden), 
                    fadeOutLeft:(outDirection === 'left' && willHidden)
                }" :style="modalStyle">
                <icon v-if="icon" style="margin:6px;" :name="icon" :color="iconColor" size="52" />
                <div class="title">{{title}}</div>
                <div class="text">{{text}}</div>
                <div v-if="type==='form'">
                    <div v-for="field in fields">
                        <inputi 
                            :label="field.label" 
                            :placeholder="field.placeholder" 
                            v-model="formData[field.name]"
                            v-if="field.type==='input'" 
                        />
                    </div>
                </div>


                <inputi 
                    :value="input" 
                    v-if="type=='input'" 
                    @change="(value)=>{input=value}"
                    :placeholder="placeholder"

                />
                <btn type="danger" size="large" @press="cancel" :label="cancelButtonLabel" v-if="showCancelButton" />
                <btn type="primary" size="large" :label="buttonLabel" @press="ok" />
            </div>
        </div>
    </div>
</template>
<script>
let audio = document.createElement("audio");
audio.volume = 0.1;

let sounds = require('./sounds.js');
function sound(sound) {
    audio.src = sounds[sound];
    audio.play();
}


export default {
    name: "alert",
    props: [],
    data() {
        return {
            formData: {},
            input: 'Песнь льда и пламени',
            title:"Внимание",
            text:"Вы что то делаете",
            icon:"check-circle",
            iconColor:"#4bc32f",
            buttonLabel:"Я понял",
            cancelButtonLabel:"Отмена",
            placeholder:"Плейсхолдер",
            willHidden:false,
            visible:false,
            outDirection:'right',
            formConfig:{fields:[]},
            showCancelButton: false,
            width:200,
            height:200,
            type:'alert'
        }
    },
    methods: {
        showInput() {
            window.iAlert.input({}).then((formInput) => {
                console.log(formInput)
            });
        },
        showAlert(alerter, config) {
            window.iAlert[alerter](config);
        },
        showConfirm() {
            window.iAlert.confirm();
        },
        showInputFrom() {
            window.iAlert.inputForm({
                fields: []
            }).then((formInput) => {
                console.log(formInput)
            });
        },
        hide(direction = 'left') {
            this.willHidden = true;
            this.outDirection = direction;
            setTimeout(()=>{
                this.willHidden = false;
                this.visible = false;
            },314);
        },
        ok() {
            this.hide('right');
            sound('finish');
            this.resolve();
        },
        cancel() {
            sound('cancel');
            this.hide('left');
            this.reject();
        },
        setData(data){
            let self = this;
            Object.keys(data).forEach((key)=>{
                self[key] = data[key];
            });
        }
    },
    mounted() {
        let self = this;
        window.iAlert = {
            alert({
                title = "Alert title",
                text = "Alert message",
                buttonLabel = 'Ok'
            }) {
                sound('alert');
                return new Promise((resolve, reject) => {
                    self.resolve = resolve;
                    self.reject = reject;
                    self.setData({
                        buttonLabel,
                        title,
                        text,
                        visible: true,
                        type: 'alert',
                        icon: "exclamation-circle",
                        iconColor: "#c3912f",
                        showCancelButton: false,
                        width: 244,
                        height: 170
                    });
                });
            },
            success({
                title = "Success",
                text = "Success message",
                buttonLabel = 'Ok'
            }) {
                sound('alert');
                return new Promise((resolve, reject) => {
                    self.resolve = resolve;
                    self.reject = reject;
                    self.setData({
                        title,
                        text,
                        visible: true,
                        type: 'alert',
                        icon: "check-circle",
                        iconColor: "#4bc32f",
                        showCancelButton: false,
                        width: 244,
                        height: 170
                    });
                });
            },
            error({
                title = "Error",
                text = "Error message",
                buttonLabel = 'Ok'
            }) {
                sound('cancel');
                return new Promise((resolve, reject) => {
                    self.resolve = resolve;
                    self.reject = reject;
                    self.setData({
                        buttonLabel,
                        title,
                        text,
                        visible: true,
                        type: 'alert',
                        icon: "exclamation-circle",
                        iconColor: "#c32f2f",
                        showCancelButton: false,
                        width: 244,
                        height: 170
                    });
                });
            },
            confirm(config = {}) {
                let {
                    title = "Хотите продолжить?",
                    text = "Нажмите да если да. нет если нет",
                    cancelButtonLabel = "Нет",
                    buttonLabel = "Да",
                } = config;
                sound('info');
                return new Promise((resolve, reject) => {
                    self.resolve = resolve;
                    self.reject = reject;
                    self.setData({
                        title,
                        cancelButtonLabel,
                        buttonLabel,
                        text,
                        visible: true,
                        type: 'confirm',
                        icon: "question-circle",
                        iconColor: "#2fb3c3",
                        showCancelButton: true,
                        width: 244,
                        height: 190
                    });
                });
            },
            input(config = {}) {
                let {
                    title = "Введите данные",
                    text = "Введите необходимые данные",
                    cancelButtonLabel = "Отмена",
                    buttonLabel = "Подтвердить ввод",
                } = config;
                sound('info');
                return new Promise((resolve, reject) => {
                    self.resolve = () => resolve(self.input);
                    self.reject = () => reject(self.input);
                    self.setData({
                        title,
                        text,
                        cancelButtonLabel,
                        buttonLabel,
                        visible: true,
                        type: 'input',
                        icon: false,
                        showCancelButton: true,
                        width: 344,
                        height: 160
                    });
                });
            },
            inputForm({
                fields = [{
                        type: "input",
                        label: 'Очки',
                        placeholder: 'Введите очки',
                        name: 'points'
                    },
                    {
                        type: "input",
                        label: 'Балы',
                        placeholder: 'Введите баллы',
                        name: 'balls'
                    }
                ],
                title = "Введите данные",
                text = "Введите необходимые данные",
                cancelButtonLabel = "Отмена",
                buttonLabel = "Подтвердить ввод",
            }) {
                sound('info');
                return new Promise((resolve, reject) => {
                    self.resolve = () => resolve(self.formData);
                    self.reject = reject;
                    self.setData({
                        title,
                        text,
                        fields,
                        cancelButtonLabel,
                        buttonLabel,
                        visible: true,
                        type: 'form',
                        icon: false,
                        showCancelButton: true,
                        width: 344,
                        height: 110 + (fields.length * 32)
                    });
                });
            },
            hide() {
                self.hide();
            }
        };

    },
    computed: {
        modalStyle() {
            return {
                width: `${this.width}px`,
                marginLeft: `${-this.width/2}px`,
                height: `${this.height}px`,
                marginTop: `${-this.height/2}px`
            };
        }
    }

}
</script>

<style scoped>
body.stop-scrolling {
    height: 100%;
    overflow: hidden;
}


.overlay {
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    top: 0;
    left: 0;
    animation-duration: .314s;
    z-index: 9999999;
}

.overlay.hidden {
    display: none;
}

.imodal {
    height: 100px;
    border: 1px solid lightgrey;
    background: white;
    margin: auto;
    top: 50%;
    left: 50%;
    position: absolute;
    border-radius: 4px;
    padding: 4px;

    animation-duration: .314s;
}


.title {
    font-weight: bold;
    font-size: 20px;
}

.text {
    margin: 8px 0;
}


















/*ANIMATIONS*/

@keyframes fadeOutLeft {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
}
.animated{
  -webkit-animation-duration: 0.314s;
  animation-duration: 0.314s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}





@-webkit-keyframes fadeOut {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

.fadeOut {
  -webkit-animation-name: fadeOut;
  animation-name: fadeOut;
}


@keyframes fadeOutLeft {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
}

.fadeOutLeft {
  -webkit-animation-name: fadeOutLeft;
  animation-name: fadeOutLeft;
}


@keyframes fadeOutRight {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
}

.fadeOutRight {
  -webkit-animation-name: fadeOutRight;
  animation-name: fadeOutRight;
}





@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.fadeIn {
  -webkit-animation-name: fadeIn;
  animation-name: fadeIn;
}


@keyframes fadeInLeft {
  from {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

.fadeInLeft {
  -webkit-animation-name: fadeInLeft;
  animation-name: fadeInLeft;
}


</style>